var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTransportRailway({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.586 2h-.636a2.5 2.5 0 0 0-2.45-2h-3a2.5 2.5 0 0 0-2.45 2h-.636A3.414 3.414 0 0 0 4 5.414V18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5.414A3.414 3.414 0 0 0 16.586 2ZM10 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm1 5H6v6h5V8Zm7 0h-5v6h5V8ZM8 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18h2l-1.333 4h8.666L15 18h2l2 6H5l2-6Z",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTransportRailway);
export default __webpack_public_path__ + "static/media/ic_action_transport_railway.664a7c4502fd6a10cb155ccd724e55a5.svg";
export { ForwardRef as ReactComponent };